import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { payOnAccountFeature } from './reducers';

@NgModule({
  imports: [StoreModule.forFeature(payOnAccountFeature)],
})
export class PayOnAccountStoreModule {}
